import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import { logoutAdmin } from "../../../Redux/Auth/AuthActions";
import { AppDispatch, RootState } from "../../../Redux/store";
import { useDispatch, useSelector } from "react-redux";
import { RxHamburgerMenu } from "react-icons/rx";
import styles from "./MobileHeader.module.scss";
import useClick from "../../../Util/useClick";
import Logo from "../../../Assets/Logo.png";
import { FaRegBell } from "react-icons/fa";
import Sidebar from "../Sidebar/Sidebar";
import { Link } from "react-router";
import React from "react";

function MobileHeader() {
  const dispatch = useDispatch<AppDispatch>();
  const { admin, adminToken } = useSelector((state: RootState) => state.auth);
  const { ref, isActive, setIsActive } = useClick(false);

  const isDoorAdminRole = admin?.role === "DoorLogAdmin";
  return (
    <React.Fragment>
      {!isDoorAdminRole && (
        <div
          className={`${styles.sidebarOverlayContainer} ${isActive ? styles.sidebarOverlayContainerActive : ""}`}
        >
          <div
            ref={ref}
            className={`${styles.sidebarContainer} ${isActive ? styles.sidebarContainerActive : ""}`}
          >
            <Sidebar />
          </div>
        </div>
      )}
      <div className={styles.mainContainer}>
        {!isDoorAdminRole && (
          <div className={styles.iconContainer}>
            <RxHamburgerMenu
              className={styles.icon}
              onClick={() => setIsActive(true)}
            />
          </div>
        )}
        <div className={styles.logoContainer}>
          <img src={Logo} alt="logo" />
        </div>
        {!admin && !adminToken && (
          <div className={styles.menuContainer}>
            <Link className={styles.loginButton} to="/login" replace>
              Login
            </Link>
          </div>
        )}
        {admin && adminToken && (
          <div className={styles.menuContainer}>
            {!isDoorAdminRole && (
              <div className={styles.notificationContainer}>
                <FaRegBell className={styles.icon} />
              </div>
            )}

            <Menu
              menuButton={
                <MenuButton>
                  <div className={styles.menuItem}>
                    {admin && (
                      <p>
                        {admin?.name?.split(" ")[0][0] +
                          admin?.name?.split(" ")[1][0]}
                      </p>
                    )}
                  </div>
                </MenuButton>
              }
              transition
            >
              <MenuItem onClick={() => dispatch(logoutAdmin())}>
                Logout
              </MenuItem>
            </Menu>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default MobileHeader;
